module.exports = __webpack_public_path__ + "img/heart-black.33e7c4e3.svg";